import { useState } from "react";
import { IoAddOutline } from "react-icons/io5";

import TextboxSearch from "../../../components/common/TextboxSearch";
import TableControls from "../../../components/common/TableControls";
import Modal from "../../../components/common/Modal";
import S2LicenseForm from "./S2LicenseForm";

const S2LicenseHeader = (props) => {
  const { account, settings, onFilter, onSearch, onSuccess } = props;

  const [showForm, setShowForm] = useState(false);

  return (
    <div className="block lg:flex justify-between items-center">
      <div>
        <p className="text-gray-500 text-sm">S2 Licenses</p>
        <span className="text-gray-400 text-xs">List of S2 Licenses</span>
      </div>
      <div className="mt-5 lg:mt-0 block md:flex md:space-x-2">
        <TextboxSearch placeholder="Search..." onSearch={onSearch} />
        <TableControls onFilter={() => onFilter(true)} settings={settings} />
        <button
          className="button button-primary mt-2 md:mt-0"
          onClick={() => setShowForm(true)}
        >
          <IoAddOutline className="mr-2" />
          Create S2 License
        </button>
        <Modal
          title="Create S2 License"
          isOpen={showForm}
          onClose={() => setShowForm(false)}
          borderTop
        >
          <S2LicenseForm
            account={account}
            setShowForm={setShowForm}
            onSuccess={onSuccess}
          />
        </Modal>
      </div>
    </div>
  );
};

export default S2LicenseHeader;
